import { WidgetText, WidgetTitle, WrapperWidget } from '@agentselly/ui';
import { EmptyState } from '~/components/empty/EmptyState';
import { AppLink } from '~/components/AppLink';
import { T } from '@tolgee/react';
import { Button } from '~/components/ui/Button';
import { clsx } from 'clsx';

interface Props {
  readonly interestedBuyers?: number;
  readonly link: string;
  readonly showDemoWidgetContent?: boolean;
}

export function MarketInterestWidget(props: Props) {
  if (
    (props.interestedBuyers === null || props.interestedBuyers === undefined) &&
    !props.showDemoWidgetContent
  ) {
    return (
      <WrapperWidget>
        <EmptyState
          title={<T>widget_market_interest_title</T>}
          description={t('empty_no_data_available')}
        />
      </WrapperWidget>
    );
  }

  return (
    <WrapperWidget>
      <div
        className={clsx('h-full flex flex-col gap-y-6', {
          'opacity-50': props.showDemoWidgetContent,
        })}
      >
        <WidgetTitle>
          <T>widget_market_interest_title</T>
        </WidgetTitle>
        <div className="">
          <WidgetText>
            <T>widget_market_interest_interested_buyers_text</T>
          </WidgetText>
          <WidgetText className="text-3xl font-extrabold mt-4">
            {props.showDemoWidgetContent ? 77 : props.interestedBuyers}
          </WidgetText>
          <WidgetText>
            <b>
              <T>widget_market_interest_interested_buyers</T>
            </b>
          </WidgetText>
        </div>
        <div>
          {!props.showDemoWidgetContent && (
            <AppLink
              className="self-start"
              to={props.link}
            >
              <Button showArrow>
                <T>widget_evaluation_button_text</T>
              </Button>
            </AppLink>
          )}
        </div>
      </div>
    </WrapperWidget>
  );
}
